
export default (async () => {
    if(!window.location.pathname.startsWith('/cart')) return;
})
();